export const Estado = [
    {
        codigoEstado: 0,
        nombreEstado: "PENDIENTE"
    }, {
        codigoEstado: 1,
        nombreEstado: "EXCEPCION"
    }, {
        codigoEstado: 2,
        nombreEstado: "NEGADO"
    }, {
        codigoEstado: 3,
        nombreEstado: "OK"
    }, {
        codigoEstado: 4,
        nombreEstado: "ERROR"
    }];

export const obtenerEstado = (nombreEstado: string) => {
    return Estado.find(estado => estado.nombreEstado === nombreEstado);
};

export const obtenerEstadoNombre = (codigoEstado: number) => {
    return Estado.find(estado => estado.codigoEstado === codigoEstado);
};



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modelo/Estado.ts